import { getCommonStyle } from '../styleCommon';

export function getGridStyles() {

	const commonAccentPrimary = getCommonStyle('color.accent.primary');
	const commonAccentSecondary = getCommonStyle('color.accent.secondary');

	return {
		background: { color: null },
		color: commonAccentSecondary,
		extension: 0,
		horizontal: {
			color: null,
			extension: null,
			lineDash: '1,1',
			normalize: {
				color: null,
				lineDash: null,
				width: null
			},
			width: null
		},
		lineDash: '',
		vertical: {
			alt: {
				color: commonAccentPrimary,
				extension: null,
				lineDash: null,
				width: null
			},
			color: null,
			extension: null,
			lineDash: '1,1',
			normalize: {
				color: null,
				lineDash: null,
				width: 1.5
			},
			width: null
		},
		width: 1
	};
}
